import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initializeSmoothScroll, scrollTo } from './utils/smoothScroll';
import Lenis from 'lenis';
import { startVersionCheck } from './utils/versionCheck';
import SEOHead from "./components/SEOHead";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import LogoMarquee from "./components/LogoMarquee";
import NewsSection from "./components/NewsSection";
import AboutSection from "./components/AboutSection";
import BlogSection from "./components/BlogSection";
import ServicesSection from "./components/ServicesSection";
import StorySection from "./components/StorySection";
import TestimonialsSection from "./components/TestimonialsSection";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import CookieBanner from "./components/CookieBanner";
import AdminPage from "./pages/AdminPage";
import InsightPage from "./pages/InsightPage";
import ArticlePage from "./pages/ArticlePage";
import ServicePage from "./pages/ServicePage";
import MetodoPage from "./pages/MetodoPage";
import ServiziPage from "./pages/ServiziPage";
import RisultatiPage from "./pages/RisultatiPage";
import ChiSonoPage from "./pages/ChiSonoPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";

// Start version check on app load
startVersionCheck();

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Wait for old route/modal effects to release their locks first.
    const frame = requestAnimationFrame(() => scrollTo(0, { immediate: true }));
    return () => cancelAnimationFrame(frame);
  }, [pathname]);
  
  return null;
};

const Home = () => {
  return (
    <div className="min-h-screen">
      <SEOHead page="home" />
      <Navbar />
      <HeroSection />
      <LogoMarquee />
      <NewsSection />
      <AboutSection />
      <BlogSection />
      <ServicesSection />
      <StorySection />
      <TestimonialsSection />
      <Footer />
      <Chatbot />
    </div>
  );
};

function App() {
  // Initialize Lenis smooth scroll
  useEffect(() => initializeSmoothScroll(Lenis), []);

  // Disable right-click context menu globally
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    
    document.addEventListener('contextmenu', handleContextMenu);
    
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/insight" element={<InsightPage />} />
            <Route path="/insight/:id" element={<ArticlePage />} />
            <Route path="/servizi/:slug" element={<ServicePage />} />
            <Route path="/metodo" element={<MetodoPage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/risultati" element={<RisultatiPage />} />
            <Route path="/chi-sono" element={<ChiSonoPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
